// ESTILOS
import styles from '../../estilos/inicioRegistro.module.css';
import { pixelRegistroCompletado, pixelSuscribirKlaviyo } from '../../funcionesDatos/pixelFacebook';
import { gtagRegistroCompletado, gtagSuscribirKlaviyo } from '../../funcionesDatos/pixelGoogle';
import { ttqRegistroCompletado, ttqSuscribirKlaviyo } from '../../funcionesDatos/pixelTiktok';
import { eventoRegistroCompletado, eventoSuscribirKlaviyo, eventoOnboardingStep } from '../../funcionesDatos/eventoPropio';
// PAQUETES
import {useEffect, useState} from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { useNavigate, useLocation, useOutletContext, useParams } from "react-router-dom";
// COMPONENTES
import FooterInicioRegistro from '../../partials/footerInicioRegistro';
import ZonaCargando from '../alertas/zonaCargando';
import SincronizarGoogle from './sincronizarGoogle';
import HelmetSEO from '../../componentesEspeciales/helmetSEO';


function Registro() {

    // Declaramos navigate para redirección
    const navigate = useNavigate();
    const location = useLocation();
    const { referidoPor } = useParams(); // username del usuario que invitó: /:referidoPor/te-invito-a-zervicy
    const { returnTo, returnState } = location.state || {}; // páginas a las que se debe volver en dado caso, como reserva o otroas.
    const { usuario, cargandoUsuario, setUsuario } = useOutletContext() || {}; // variables de context
    const [cargando, setCargando] = useState(false);
    const [mostrarPassword, setMostrarPassword] = useState(false);
    const [mostrarConfirmarPassword, setMostrarConfirmarPassword] = useState(false);
    const [existe, setExiste] = useState(null);
    const [aceptaMarketing, setAceptaMarketing] = useState(true);
    
    // declaración objeto inicial
    const[input, setInput]        = useState ({
        email: "",
        username: "",
        nombre: "",
        apellido: "",
        password: "",
        confirmarPassword: ""
    });
    

    // Se dispara una sola vez al montar la pantalla de registro (funnel de onboarding).
    useEffect(() => {
        eventoOnboardingStep({ step: "ver_formulario_registro" });
    }, []);

    // UseEffect verificar que el usuario que invita exista.
    useEffect(() => {
        if(!referidoPor){
            setExiste(true);
            return;
        }

        (async() => {
            try{
                setCargando(true);

                const resVerif = await axios.post("/verificar-existe-usuario", {
                    params: { username: referidoPor }
                });

                setExiste(Boolean(resVerif?.data?.existe));
            }
            catch(err){
                console.log("error verificando usuario referido:", err);
                setExiste(false);
            }
            finally{
                setCargando(false);
            }
        })();
    }, [referidoPor]);


    // cambiar el valor por el que escribe el usuario
    function handleChange(event) {
        const { name, value } = event.target;

        // Filtrar solo para el campo "username"
        const filteredValue = name === "username" 
            ? value.replace(/[^A-Za-z0-9]/g, '')  // Permitir solo letras y números sin espacios
            : value;  // Para otros campos, dejar el valor sin filtrar

        // guardar el valor previo.
        setInput(prevInput => {
            return {
                ...prevInput,
                [name]: filteredValue
            };
        });
    }

    function mostrarAyuda(campo){
        let titulo = 'Información';
        let texto = '';

        if(campo === 'email'){
            titulo = 'Email';
            texto = 'Único e irrepetible.';
        }
        if(campo === 'nombre'){
            titulo = 'Nombre';
            texto = 'Solo tu nombre (sin apellidos).';
        }
        if(campo === 'username'){
            titulo = 'Usuario';
            texto = 'Alfanumérico. Sin puntos, comas, símbolos ni espacios.';
        }
        if(campo === 'password'){
            titulo = 'Contraseña';
            texto = 'Mínimo 4 caracteres.';
        }
        if(campo === 'confirmarPassword'){
            titulo = 'Confirmar contraseña';
            texto = 'Escribe la misma contraseña de arriba.';
        }

        return Swal.fire({
            icon: 'info',
            title: titulo,
            text: texto,
            confirmButtonText: 'Ok',
            customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
        });
    }

    // se activa cuando se oprime el botón
    function handleClick(event){
        // evita el parpadeo predefinido
        event.preventDefault();

        // crear objeto para pasar a servidor
        const nUsuario = {
            email: input.email,
            username: input.username,
            nombre: input.nombre,
            apellido: input.apellido,
            password: input.password,
            referidoPor: referidoPor || "NA",
            aceptaMarketing: aceptaMarketing,
        }

        if(input.password !== input.confirmarPassword){
            Swal.fire({
                icon: 'error',
                title: 'Contraseñas diferentes',
                text: 'La confirmación de contraseña no coincide.',
                confirmButtonText: 'Ok',
                customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
            });
            return;
        }

        // Creamos variables para verificar username
        var validarEspacio = /\s/; // Contiene espacios
        var validarPalabra = /\W/; // Coincide con cualquier carácter que no sea una palabra .
        // Si tiene errores el usuario
        if(validarEspacio.test(nUsuario.username) || validarPalabra.test(nUsuario.username)){
            Swal.fire({
                icon: 'error',
                title: 'Error en usuario',
                text: 'Sin espacios, solo letras y números. Al menos 4 caracteres.',
                confirmButtonText: 'Ok',
                customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
            }).then((result) => {
                if (result.isConfirmed) { window.location.reload(); }
            });
            return;
        }
        else{
            eventoOnboardingStep({ step: "envio_formulario" });

            // si no tiene errores el usuario entonces pasamos datos a servidor o bd.
            axios.post("/registrar", nUsuario)
            .then(function (response) {
                // Si el usuario ya existe redireccionamos a alerta para crear nuevamente
                if(response.data.existe){
                    eventoOnboardingStep({ step: "error_usuario_existente" });
                    Swal.fire({
                        icon: 'error',
                        title: 'Usuario ya existe',
                        text: 'El usuario ya existe, por favor intenta con otro usuario.',
                        confirmButtonText: 'Ok',
                        customClass: { popup: 'mi-modal', confirmButton: 'mi-boton-confirmar' }
                    }).then((result) => {
                        if (result.isConfirmed) {
                            window.location.reload();
                        }
                    });
                    return;
                }
                // Si no existe, es decir ya se creó, entonces redireccionamos a iniciar sesión
                else if(response.data.existe===false){
                    eventoOnboardingStep({ step: "registro_completado" });
                    pixelRegistroCompletado({ metodo: "email" });
                    gtagRegistroCompletado({ metodo: "email" });
                    ttqRegistroCompletado({ metodo: "email" });
                    eventoRegistroCompletado({ metodo: "email", usuarioId: null });
                    if (aceptaMarketing) pixelSuscribirKlaviyo({ origen: "registro" });
                    if (aceptaMarketing) gtagSuscribirKlaviyo({ origen: "registro" });
                    if (aceptaMarketing) ttqSuscribirKlaviyo({ origen: "registro" });
                    if (aceptaMarketing) eventoSuscribirKlaviyo({ origen: "registro", usuarioId: null });
                    return navigate("/iniciar-sesion", {
                        state: {
                            returnTo,
                            returnState,
                        }
                    });
                }
            })
            .catch(function(err){console.log(err);});
        }
    }


    return(
        <>

            {/*
                SEO dinámico de registro.
                Cambia automáticamente:
                - título
                - descripción SEO
                - Open Graph
                para buscadores y redes sociales.
            */}
            <HelmetSEO
                titulo="Crear cuenta | Zervicy"
                descripcion="Crea tu cuenta en Zervicy para reservar servicios, publicar tus habilidades y conectar con nuevos clientes."
            />
        <div className={styles.containerRegistro}>
        { (cargando) ? <ZonaCargando />
        : existe === false ? (
            <main className={styles['form-signin']}>
                <div className="card border-0 shadow-lg rounded-4 text-center p-4">
                    <div className="mb-3">
                        <i className="bi bi-person-x" style={{ fontSize: "48px", color: "var(--naranja-cta)" }} />
                    </div>

                    <h1 className="h4 fw-bold mb-2">Este usuario no existe</h1>
                    <p className="text-secondary mb-4">
                        El enlace de invitación no es válido o el usuario que te invitó ya no está disponible.
                    </p>

                    <button
                        type="button"
                        className="btn btn-primary rounded-pill px-4 py-2 fw-semibold"
                        onClick={() => navigate("/")}
                    >
                        Volver a Zervicy
                    </button>
                </div>
            </main>
        )
        :<main className={styles['form-signin']}>
            <form>
                {/* Imagen y título */}
                <div className='d-flex justify-content-center'>
                <a href='/' >
                    <img className="my-5" src="/imagenes/marca/zervicyblancohorizontal.png" alt="" height="80" />
                </a>
                </div>
                <h3 className="h3 mb-3 fw-normal text-light text-center">Registrar</h3>

                {referidoPor ? (
                    <div className="alert alert-light border-0 rounded-4 py-2 px-3 text-center" style={{ fontSize: "13px" }}>
                        Te invitó <b>@{referidoPor}</b>. Crea tu cuenta para continuar en Zervicy.
                    </div>
                ) : null}


                {/* Email */}
                <div className="form-floating mb-2 position-relative">
                    <input onChange={handleChange} value={input.email} name="email" type="email" className="form-control" id="floatingInput" placeholder="name@example.com" />
                    <label htmlFor="floatingInput">Email</label>

                    <button
                        type="button"
                        className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3"
                        onClick={() => mostrarAyuda('email')}
                        aria-label="Ayuda Email"
                        title="Ayuda"
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="bi bi-question-circle text-dark" style={{ opacity: 0.75 }} />
                    </button>
                </div>

                {/* nombre */}
                <div className="form-floating mb-2 position-relative">
                    <input onChange={handleChange} value={input.nombre} name="nombre" type="text" className="form-control"  placeholder="mi nombre" />
                    <label htmlFor="floatingInput">Nombre</label>

                    <button
                        type="button"
                        className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3"
                        onClick={() => mostrarAyuda('nombre')}
                        aria-label="Ayuda Nombre"
                        title="Ayuda"
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="bi bi-question-circle text-dark" style={{ opacity: 0.75 }} />
                    </button>
                </div>


                {/* username */}
                <div className="form-floating mb-2 position-relative">
                    <input onChange={handleChange} value={input.username} required name="username" type="text" className="form-control"  placeholder="miusuario123" pattern="[A-Za-z0-9]*"  title="Sin espacios, solo letras y números. Al menos 4 caracteres." />
                    <label htmlFor="floatingInput">Usuario</label>

                    <button
                        type="button"
                        className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3"
                        onClick={() => mostrarAyuda('username')}
                        aria-label="Ayuda Usuario"
                        title="Ayuda"
                        style={{ textDecoration: 'none' }}
                    >
                        <i className="bi bi-question-circle text-dark" style={{ opacity: 0.75 }} />
                    </button>
                </div>

                {/* Password  */}
                <div className="form-floating mb-2 position-relative">
                    <input onChange={handleChange} value={input.password} name="password" type={mostrarPassword ? "text" : "password"} className="form-control pe-5" id="floatingPassword" placeholder="Password" title="Sin espacios, solo letras y números. Al menos 4 caracteres." />
                    <label htmlFor="floatingPassword">contraseña</label>

                    <button
                        type="button"
                        className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3"
                        onClick={() => setMostrarPassword(!mostrarPassword)}
                        aria-label={mostrarPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                        title={mostrarPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                        style={{ textDecoration: 'none', zIndex: 2 }}
                    >
                        <i className={`bi ${mostrarPassword ? 'bi-eye-slash' : 'bi-eye'} text-dark`} style={{ opacity: 0.75 }} />
                    </button>

                    <button
                        type="button"
                        className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-5"
                        onClick={() => mostrarAyuda('password')}
                        aria-label="Ayuda Contraseña"
                        title="Ayuda"
                        style={{ textDecoration: 'none', zIndex: 2 }}
                    >
                        <i className="bi bi-question-circle text-dark" style={{ opacity: 0.75 }} />
                    </button>
                </div>

                {/* Confirmar Password */}
                <div className="form-floating mb-2 position-relative">
                    <input onChange={handleChange} value={input.confirmarPassword} name="confirmarPassword" type={mostrarConfirmarPassword ? "text" : "password"} className="form-control pe-5" id="floatingConfirmarPassword" placeholder="Confirmar Password" title="Escribe la misma contraseña de arriba." />
                    <label htmlFor="floatingConfirmarPassword">confirmar contraseña</label>

                    <button
                        type="button"
                        className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-3"
                        onClick={() => setMostrarConfirmarPassword(!mostrarConfirmarPassword)}
                        aria-label={mostrarConfirmarPassword ? "Ocultar confirmación de contraseña" : "Mostrar confirmación de contraseña"}
                        title={mostrarConfirmarPassword ? "Ocultar confirmación de contraseña" : "Mostrar confirmación de contraseña"}
                        style={{ textDecoration: 'none', zIndex: 2 }}
                    >
                        <i className={`bi ${mostrarConfirmarPassword ? 'bi-eye-slash' : 'bi-eye'} text-dark`} style={{ opacity: 0.75 }} />
                    </button>

                    <button
                        type="button"
                        className="btn btn-link p-0 position-absolute top-50 end-0 translate-middle-y me-5"
                        onClick={() => mostrarAyuda('confirmarPassword')}
                        aria-label="Ayuda Confirmar Contraseña"
                        title="Ayuda"
                        style={{ textDecoration: 'none', zIndex: 2 }}
                    >
                        <i className="bi bi-question-circle text-dark" style={{ opacity: 0.75 }} />
                    </button>
                </div>

                {/* Botón registrar */}
                <button onClick={handleClick} className="btn btn-primary w-100 py-2" type="submit">
                    <i className="bi bi-person-plus me-2" />
                    Registrar
                </button>

                {/* Línea divisora con "o" en el centro */}
                <div className="d-flex align-items-center my-1 w-100">
                    <hr className="flex-grow-1 border-white" />
                    <span className="mx-2 text-white">o</span>
                    <hr className="flex-grow-1 border-white" />
                </div>

                {/* Botón de Google */}
                <SincronizarGoogle usuario={"desdeInicio"} referidoPor={referidoPor} aceptaMarketing={aceptaMarketing} returnTo={returnTo} />

                {/* Checkbox marketing — aplica para ambas formas de registro */}
                <div className="form-check mt-3">
                    <input
                        className="form-check-input"
                        type="checkbox"
                        id="aceptaMarketing"
                        checked={aceptaMarketing}
                        onChange={(e) => setAceptaMarketing(e.target.checked)}
                    />
                    <label className="form-check-label text-white small" htmlFor="aceptaMarketing">
                        Quiero recibir novedades y promociones de Zervicy. Aplica para cualquier método de registro. (Opcional)
                    </label>
                </div>

                
                {/* footer */}
                <FooterInicioRegistro />  
            </form>
        </main>
        }
        </div>
        </>
    )
}


export default Registro; 